import { createRef, useContext } from "react";
import JSONSchemaForm from "@rjsf/core";
import CrudModuleFactoryModal from "@beeldit/core/components/CrudModuleFactoryModal";
// import useGet from "./useGet";
import useUpdate from "./useUpdate";
import SuperOrderForm from "@beeldit/ecommerce/super-orders/components/SuperOrderForm";
import { EditBillingAddressActionContext } from "./EditBillingAddressActionContext";
import SuperOrderBillingAddressForm from "../../components/SuperOrderBillingAddressForm";

function useEditBillingAddressAction(onSuccess: any): any {

  // const get = useGet();
  // const getFunction = (id: number) => get(id);

  /**
   * Form store success function definition
   */
  const onSuccessUpdate = () => {
    setShowModal(false);
    onSuccess(); // We pass the function to refresh the table on success
  };

  const showModal = (element: any) => {
    // Añadimos un campo billing_address_form con valor true al elemento
    element.billing_address_form = true;
    element.shipping_address_form = false;
    element.observation_form = false;
    setElement(element);
    setShowModal(true);
  };

  const update = useUpdate();
  const updateFunction = () => update(onSuccessUpdate);

  const contextInstance = useContext(EditBillingAddressActionContext);
  const { element, setElement, setShowModal } = contextInstance;


  /**
   * Form Reference definition
   */
  const formRef = createRef<JSONSchemaForm>();

  /**
   * Creation and edition modal configuration definition
   */
  const modalConfig = {
    title: "billing-address",
    contextInstance: contextInstance,
    onSubmit: () => formRef.current?.formElement.current.requestSubmit(), //We pass the function for the submit of the modal
    size: "modal-lg",
  };

  /**
   * Form configuration definition
   */
  const formConfig = {
    formRef: formRef, // We pass the ref to the form
    onSubmit: () => {
      updateFunction();
    },
    element: element, // We pass the element to the form in order to render it in the modal form
    context: EditBillingAddressActionContext,
    action: 'edit',
    className: "super-order-form",
  };

  const actionTemplate = (
    <CrudModuleFactoryModal modalConfig={modalConfig}>
      <SuperOrderBillingAddressForm formConfig={formConfig} />
    </CrudModuleFactoryModal>
  );

  /** END EDIT FORM ACTION */

  return {
    showModal,
    actionTemplate,
  };
}

export default useEditBillingAddressAction;
